module.exports = __webpack_public_path__ + "img/square-full.994210a9.svg";